export class Bonus {
    constructor(scene) {
        this.scene = scene;
        this.bonusContainer = this.scene.add.container();
        this.timers = [];
    }

    init(callback) {
        this.callback = callback;

        if(this.scene.slots.spinStarted) {
            return;
        }

        this.playBonusText();
    }

    reset() {
        for(const [ timerIndex, timer ] of Object.entries(this.timers)) {
            timer.remove();
            delete this.timers[timerIndex];
        }

        for (const sprite of this.bonusContainer.getAll()) {
            if(sprite.tween && sprite.tween.isPlaying()) {
                sprite.tween.remove();
            }

            if(sprite.anims) {
                if(sprite.anims.isPlaying) {
                    sprite.anims.pause();
                }
            }

            sprite.destroy();
        }

        if(this.bonusSymbols) {
            for (const sprite of this.bonusSymbols) {
                sprite.alpha = 1;
            }
        }

        this.bonusContainer.removeAll();

        this.bonusSymbols = undefined;

        this.doCallback();
    }

    doCallback() {
        if(this.callback) {
            this.callback();
        }

        this.callback = undefined;
    }

    playBonusText() {
        this.scene.showWinning('BONUS', () => {
            this.reset();
        });
    }
}